(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("toast", [], factory);
	else if(typeof exports === 'object')
		exports["toast"] = factory();
	else
		root["toast"] = factory();
})(this, function() {
return 